import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "38",
  fill: "none",
  viewBox: "0 0 37 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "38",
      height: "37",
      y: "38",
      fill: "#1A523D",
      rx: "9",
      transform: "rotate(-90 0 38)"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.474 11.079v5.526a1.106 1.106 0 0 1-1.105 1.105h-5.526v2.764a.553.553 0 0 1-.944.39l-6.631-6.631a.553.553 0 0 1 0-.782l6.631-6.632a.552.552 0 0 1 .944.391v2.763h5.526a1.105 1.105 0 0 1 1.105 1.106M30.996 24.55l-6.632 6.63a.553.553 0 0 1-.943-.39v-2.763h-5.527a1.105 1.105 0 0 1-1.105-1.105v-5.527a1.105 1.105 0 0 1 1.105-1.105h5.527v-2.763a.553.553 0 0 1 .943-.391l6.632 6.631a.553.553 0 0 1 0 .782"
    }, null, -1)
  ])))
}
export default { render: render }